/* eslint-disable */
import React, { useEffect, useCallback } from 'react';
import compose from 'lodash/fp/compose';
import { useSelector, useDispatch } from 'react-redux';
import { getFavoriteOrg } from 'actions/organisation';
import {
  withTranslation,
  withPersonalInfo,
  withDeleteConfirmation,
  withBulkDelete,
  withUserLayoutChoice,
  withCustomRouter,
  withOrganisation,
} from 'components/hoc';
import OrgContentTemplate from '../../common/OrgContentTemplate';
import './style.css';
import { useNavigate } from 'react-router-dom';


const OrganisationSelection = (props) => {
  const { favorites } = useSelector((state) => state.organisation);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Add filterableColumns configuration
  const filterableColumns = [
    {
      columnId: 'transfer_date',
      columnDataType: 'date',
    },
    {
      columnId: 'name',
      columnDataType: 'text',
    },
    {
      columnId: '_legal_form',
      columnDataType: 'text',
    },
    {
      columnId: '_industry',
      columnDataType: 'text',
    },
    {
      columnId: '_org_country',
      columnDataType: 'text',
    },
    {
      columnId: '_state',
      columnDataType: 'text',
    },
    {
      columnId: '_city_location',
      columnDataType: 'text'
    },
    {
      columnId: '_foundation',
      columnDataType: 'date'
    },
    {
      columnId: '_liquidation',
      columnDataType: 'date'
    },
    {
      columnId: '_org_motivation',
      columnDataType: 'text'
    },
    {
      columnId: '_org_motivation',
      columnDataType: 'text'
    },
    {
      columnId: '_revenue_approx',
      columnDataType: 'number'
    },
    {
      columnId: '_revenue_currency',
      columnDataType: 'text'
    },
    {
      columnId: '_register_institute',
      columnDataType: 'text'
    },
    {
      columnId: 'register_no',
      columnDataType: 'text'
    },
    {
      columnId: '_parent_org',
      columnDataType: 'text'
    },
    {
      columnId: '_no_of_employees',
      columnDataType: 'number'
    },
    {
      columnId: '_transfer_date',
      columnDataType: 'date'
    },
    {
      columnId: 'website',
      columnDataType: 'text'
    },
    {
      columnId: '_non_profit',
      columnDataType: 'boolean',
      booleanOptions: [
        { value: '\u2713', label: 'True' },
        { value: '\u2717', label: 'False' }
      ]
    },
    {
      columnId: '_legal_personality',
      columnDataType: 'boolean',
      booleanOptions: [
        { value: '\u2713', label: 'Yes' },
        { value: '\u2717', label: 'No' }
      ]
    },
    {
      columnId: '_public',
      columnDataType: 'boolean',
      booleanOptions: [
        { value: '\u2713', label: 'Yes' },
        { value: '\u2717', label: 'No' }
      ]
    }
  ];

  const mapFields = () => {
    const { trObj, fn, fd } = props;
    return favorites.map(({ id, organisation_data, space }) => {
      const {
        name,
        public: _public,
        legal_form_detail,
        ...rest
      } = organisation_data;
      
      // Truncate name to 25 characters with ellipsis
      const truncatedName = name && name.length > 25 
        ? `${name.substring(0, 25)}...` 
        : name;
        
      return {
        ...rest,
        id,
        name: truncatedName,
        space_name: space,
        _legal_form: legal_form_detail ? trObj(legal_form_detail) : '',
        _public: _public ? '\u2713' : '\u2717',
        _foundation: fd(rest.foundation),
        _liquidation: fd(rest.liquidation),
        _active: rest.active ? '\u2713' : '\u2717',
        _organisation_type: trObj(rest.organisation_type_detail),
        _org_country: trObj(rest.org_country_detail),
        _state: trObj(rest.state_detail),
        _city_location: trObj(rest.city_location_detail),
        _register_institute: rest?.register_institute?.name,
        _revenue_currency: trObj(rest.revenue_currency_detail),
        _industry: (() => { const n = trObj(rest.industry_type_detail); return n && n.length > 25 ? `${n.substring(0, 25)}...` : n; })(),
        _no_of_employees: fn(rest.no_of_employees),
        _revenue_approx: fn(rest.revenue_approx),
        _legal_personality: rest.legal_personality ? '\u2713' : '\u2717',
        _non_profit: rest.non_profit ? '\u2713' : '\u2717',
        _org_motivation: trObj(rest.org_motivation_detail),
        _parent_org: rest?.parent_org?.name,
        _organisation_logo: rest?.organisation_logo,
        _transfer_date: fd(rest.transfer_date),
      };
    });
  };

  const { deleteBulkFavoriteOrg } = props;

  // const handleOrgAction = (id, data) => {
  //   // this org function serves to differentiate between organisation
  //   // that come pre built in the system and those that were created by the user
  //   // if the organisation was created by the user move to the personal org form
  //   // else you move it to the search org form
  //   const { basePath } = props;
  //   if (data?.creator) {
  //     const pathArray = basePath.split('/');
  //     pathArray.pop();
  //     const pathway = `${pathArray.join('/')}/organisation/${data?.id}`;
  //     navigate(pathway);
  //   } else {
  //     // route to the search org form
  //     navigate(`${basePath}/${data?.id}`);
  //   }
  // };

  useEffect(() => {
    dispatch(getFavoriteOrg());
  }, []);

  const tableName = 'organisation';
  const { gotoSearchPath } = props;

  return (
    <React.Fragment>
      <OrgContentTemplate
        tableName={tableName}
        columns={[]}
        data={mapFields() || []}
        toggleForm={gotoSearchPath}
        filterableColumns={filterableColumns}
        // orgCondition
        // handleOrgAction={handleOrgAction}
        bulkDelete={deleteBulkFavoriteOrg}
      />
    </React.Fragment>
  );
};

export default compose(
  withBulkDelete,
  withTranslation,
  withPersonalInfo,
  withDeleteConfirmation,
  withUserLayoutChoice,
  withCustomRouter,
  withOrganisation,
)(OrganisationSelection);
